import Product from '@src/quince-site-common/src/domains/Product'
import Bundle from '@src/quince-site-common/src/domains/Product/BundleProduct'
import ProductCard from '@src/quince-site-common/src/domains/ProductCard'
import { ContainerConfig } from '@src/quince-site-common/src/organisms/pageBuilder'
import { TPDPSectionData } from '../types/pdp-section-data.type'
import { PDP_LAYOUT_TYPE } from '@src/quince-site-common/src/domains/contentful/ContentfulProduct'
import { LAYOUT_TYPE_VS_DESKTOP_CONTAINER_CONFIG, LAYOUT_TYPE_VS_MOBILE_CONTAINER_CONFIG } from '../layouts'

export type BundlePageContext = {
  bundle: Bundle
  mobileContainerConfig?: ContainerConfig
  desktopContainerConfig?: ContainerConfig
  recommendedContentfulProductIds: Array<string> | undefined
  recommendedProductCards?: ProductCard[]
  sectionData: TPDPSectionData
  mergeProducts?: Product[]
}

export type BundlePageBFFResponse = {
  bundle: Bundle
  mobileContainerConfig?: PDP_LAYOUT_TYPE
  desktopContainerConfig?: PDP_LAYOUT_TYPE
  recommendedContentfulProductIds: Array<string> | undefined
  recommendedProductCards?: ProductCard[]
  sectionData: TPDPSectionData
  mergeProducts?: Product[]
}

export const getBundlePageContext = ({
  bundle,
  mobileContainerConfig,
  desktopContainerConfig,
  recommendedContentfulProductIds,
  recommendedProductCards,
  sectionData,
  mergeProducts,
}: BundlePageBFFResponse): BundlePageContext => {
  return {
    bundle,
    mobileContainerConfig: mobileContainerConfig
      ? new ContainerConfig(LAYOUT_TYPE_VS_MOBILE_CONTAINER_CONFIG[mobileContainerConfig])
      : undefined,
    desktopContainerConfig: desktopContainerConfig
      ? new ContainerConfig(LAYOUT_TYPE_VS_DESKTOP_CONTAINER_CONFIG[desktopContainerConfig])
      : undefined,
    recommendedContentfulProductIds,
    recommendedProductCards,
    mergeProducts,
    sectionData,
  }
}

export default BundlePageContext

export { ContainerConfig }
